/**
 * get selected product
 * @param state
 * @returns {*|boolean}
 */

export const getProduct = state => (state.product);

export default getProduct;



// WEBPACK FOOTER //
// ./app/containers/school-roll/selectors.js